import { ResourcesActions } from "./types"
const { RESOURCES_TOGGLE } = ResourcesActions

export const toggleResources = payload => ({
    type: RESOURCES_TOGGLE,
    payload
})